<template>
  <article class="mobile-wrap">
    <header class="header flex justify-between">
      <div class="header-left">
        <img src="../../assets/images/mobile/logo.png" alt="">
      </div>
      <div class="header-center">
        <a href="javascript:;" @click="statistics('click_origin1_player', '', 'https://www.guru-game.com/origin2/mobile/origin1rewards/')"></a>
      </div>
      <div class="header-right flex justify-between">
        <a href="javascript:;" @click="statistics('go_lounge', 'lounge', 'https://game.naver.com/lounge/samgukji_origin2/home')" class="img1">
          <img src="../../assets/images/mobile/btn_naverlounge.png" alt="">
        </a>
        <a href="javascript:;" @click="statistics('go_yt', 'yt', 'https://www.youtube.com/@samgukjioringin2')" class="img2" >
          <img src="../../assets/images/mobile/btn_youtube.png" alt="">
        </a>
        <img class="img3" src="../../assets/images/mobile/btn_open.png" alt="" @click="showDialog.menu = true">
      </div>
    </header>

    <section class="content">
      <!-- page1 -->
      <a name="page1"></a>
      <section class="page page1">
        <a href="javascript:;" class="btn-video" @click="playVideo()"></a>
        <div class="link-box">
          <a href="javascript:;" @click="statistics('go_gp', 'gp', 'https://play.google.com/store/apps/details?id=com.guru.jpsgz.kr')" class="gp"><span
              class="light-effect"><i class="effect"></i></span></a>
          <a href="javascript:;" @click="statistics('go_apple', 'apple', 'https://apps.apple.com/kr/app/id6447394503')" class="app"><span class="light-effect"><i
                class="effect"></i></span></a>
          <a href="javascript:;" @click="statistics('go_onestore', 'onestore', 'https://onesto.re/0000768906')" class="one"><span class="light-effect"><i class="effect"></i></span></a>
          <a href="javascript:;" @click="statistics('go_galaxystore', 'galaxystore', 'https://galaxystore.samsung.com/detail/com.guru.jpsgz.krsamsung')" class="galaxy"><span
              class="light-effect"><i class="effect"></i></span></a>
        </div>
        <a href="https://www.guru-game.com/samgukjiorigin2" class="btn-pre"><span class="light-effect"><i class="effect"></i></span></a>
        <a href="#page2" class="btn-down"></a>
      </section>
      <!-- page2 -->
      <a name="page2"></a>
      <section class="page page5">
        <div class="swiper shopsSwiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="../../assets/images/slide_01.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/slide_02.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/slide_03.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/slide_04.png" />
            </div>
            <div class="swiper-slide">
              <img src="../../assets/images/slide_05.png" />
            </div>
          </div>
          <div class="pagination"></div>
        </div>
        <a href="javascript:;" class="btn-slide btn-prev"></a>
        <a href="javascript:;" class="btn-slide btn-next"></a>
      </section>
    </section>
    <aside class="aside" v-if="showDialog.menu === true">
      <div class="nav">
        <a v-for="(nav, index) of navs" :href="`#page${index + 1}`" :key="index"
          :class="`n${index + 1}${index === menuIndex ? ' active' : ''}`">{{ nav.title }}</a>
      </div>
      <div class="link-box">
        <a href="javascript:;" @click="statistics('go_gp', 'gp', 'https://play.google.com/store/apps/details?id=com.guru.jpsgz.kr')" class="gp"><span class="light-effect"><i
              class="effect"></i></span></a>
        <a href="javascript:;" @click="statistics('go_apple', 'apple', 'https://apps.apple.com/kr/app/id6447394503')" class="app"><span class="light-effect"><i
              class="effect"></i></span></a>
        <a href="javascript:;" @click="statistics('go_onestore', 'onestore', 'https://onesto.re/0000768906')" class="one"><span class="light-effect"><i class="effect"></i></span></a>
        <a href="https://galaxystore.samsung.com/detail/com.guru.jpsgz.krsamsung" class="galaxy"><span
            class="light-effect"><i class="effect"></i></span></a>
      </div>
      <a href="javascript:;" class="btn-close" @click="showDialog.menu = false"></a>
    </aside>

    <div v-if="showDialog.rules === true" class="popup-box popup-rules">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.rules = false"></a>
        <div class="rules">
          <h3>이벤트 유의사항</h3>
          <p><strong>1. 참여 서버:</strong> S1-S30;</p>
          <p><strong>2. 이벤트 보상:</strong> </p>
          <p>S1-S9: 1등급 한우 세트+커스텀 술잔 세트+커스텀 도장</p>
          <p>S10-S20: 1등급 한우 세트+커스텀 도장</p>
          <p>S21-S30: 1등급 한우 세트</p>
          <p><strong>3. 이벤트 설명:</strong></p>
          <p>각 서버 제4년 겨울 (해당 서버 오픈 16일째) 전공 랭킹 1위 유저님께 위 보상을 지급해 드립니다.</p>
          <p>&nbsp;</p>
          <p>더욱 자세한 이벤트 내용은 공식 라운지에서 확인하시기 바랍니다.</p>
        </div>
      </div>
    </div>
    
    <div v-if="showDialog.privacy === true" class="popup-box popup-privacy">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.privacy = false"></a>
        <div class="privacy">
          <h3>개인정보 수집 및 이용 안내</h3>
          <p>&nbsp;</p>
          <p>GURU GAMES CO., LIMITED는 &lt;삼국지 오리진2: 적벽대전&gt; 게임 정보 및 사전예약 이벤트 안내를 위해 다음과 같이 개인정보를 수집 및 이용하고 있습니다.</p>
          <p>귀하는 개인정보 수집 및 이용에 동의하지 않을 수 있으며 거부 시 사전예약 이벤트에 참여하실 수 없습니다.</p>
          <p>※ 개인정보 수집 및 이용 목적 : 사전예약 이벤트 당첨자 안내 및 게임 관련 소식 전달</p>
          <p>※ 수집하는 개인정보 항목 : 휴대폰 번호</p>
          <p>※ 개인정보 보유 및 이용기간 : 수집일로부터 1년 </p>
        </div>
      </div>
    </div>

    <div v-if="showDialog.video === true" class="popup-box popup-videos">
      <div class="inner">
        <a href="javascript:;" class="btn-close" @click="showDialog.video = false"></a>

      </div>
    </div>
  </article>
</template>

<script src="../../../public/assets/swiper-bundle.min.js"></script>

<script>
  import { gameBook, showGameBookCount } from "@/api/api";
  export default {
    name: "mobile",
    data() {
      return {
        sideSwiper: null,
        shopsSwiper: null,
        menuIndex: 0,
        navs: [{
          title: "홈페이지",
        },
        {
          title: "게임 소개",
        }],
        firstClick: true, //第一次关闭预约弹窗
        percent: 0,
        registNumbers: 0,
        hasChecked: false,
        ios: true,
        showDialog: {
          login: true,
          success: false,
          rules: false,
          video: false,
          alert: false,
          again: false, // "欢迎回来"弹窗
          menu: false,
          privacy: false,
          alertMsg: ''
        },
        isBooking: false,
        isFirstPage: true,
        lotteryActive: 0,
        style: ''
      };
    },
    created() {
      fbq('init', '1058047045571878');
      fbq('track', 'PageView');

      ttq.load('CJDE74RC77UDNVGREPM0');
      ttq.page();

      if(this.isIOS()) {
        this.ios = true
      } else {
        this.ios = false
      }
    },
    mounted() {
      this.handleScroll();
      window.addEventListener("scroll", this.handleScroll, true);
      this.swiperFunc();
      this.fitScreen();
    },
    methods: {
      statistics(name, label, url, type) {
        gtag('event', name, {'event_label': label});
        // 新开链接跳转
        if (url) {
          window.open(url);
        }
      },
      playVideo() {
        // this.showDialog.video = true
        this.statistics('playvideo', 'playvideo', 'https://youtu.be/ZU5LXNZ42tE')
      },
      fitScreen() {
        const fit = window.innerWidth / window.innerHeight
        if(fit > 2/3) {
          this.style = `-webkit-transform: scale(${fit});transform: scale(${fit});transform-origin: bottom;`
        }
      },
      clickBottomBtn() {
        if (this.ios) {
          this.statistics('go_apple', 'apple', 'https://apps.apple.com/kr/app/id6447394503')
        } else {
          this.statistics('go_gp', 'gp', 'https://play.google.com/store/apps/details?id=com.guru.jpsgz.kr')
        }
      },
      isIOS() {
        const u = navigator.userAgent;
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      },
      handleScroll () {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        
        const dom = document.querySelectorAll(".page");
        let offsetTop = 0
        for (let i = 0; i < dom.length; i++) {
          offsetTop += dom[i].clientHeight;
          if(i === dom.length - 2){
            const gap = window.innerHeight - dom[dom.length - 1].clientHeight
            if (scrollTop > offsetTop - 100 - (gap < 0 ? 0 : gap)) {
              this.menuIndex = dom.length - 1;
            }else{
              this.menuIndex = i
            }
            break;
          }
          if (scrollTop < offsetTop - 100) {
            this.menuIndex = i;
            if(scrollTop < 300){
              this.isFirstPage = false
            } else {
              this.isFirstPage = true
            }
            break;
          }
        }
      },
      backToTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      },
      swiperFunc () {
        this.shopsSwiper = new Swiper(".shopsSwiper", {
          loop: true,
          allowTouchMove: true,
          navigation: {
            nextEl: ".btn-next",
            prevEl: ".btn-prev",
          },
          pagination: {
            el: ".pagination",
            clickable: true, //允许分页点击跳转
          },
        });

        this.sideSwiper = new Swiper(".sideSwiper", {
          loop: true,
          allowTouchMove: false,
          autoplay : {
            delay: 2000
          },
          speed: 700,
          effect : 'fade',
          fadeEffect: {
            crossFade: true,
          }
        });
      },
    }
  };
</script>

<style lang="less" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 102rem;
  background: rgba(0, 0, 0, .8);

  .header-left {
    width: 130rem;
    height: 130rem;
    margin-left: 7rem;

    img {
      width: 130rem;
      height: 130rem;
    }
  }

  .header-center {
    position: absolute;
    left: 50%;
    top: 10rem;
    z-index: 102;
    width: 245rem;
    height: 80rem;
    margin-left: -122rem;
    background: url(../../assets/images/mobile/top_ad.png) no-repeat;
    background-size: 100% 100%;
    a{
      display: block;
      width: 245rem;
      height: 80rem;
    }
  }

  .header-right {
    width: 157rem;
    margin-top: 36rem;
    margin-right: 30rem;

    // img {
    //   width: 70rem;
    //   height: 70rem;
    // }
    a {
      display: block;
      img {
        width: 100%;
        height: 37rem;
      }
    }

    .img1 {
      width: 46rem;
    }

    .img2 {
      width: 38rem;
    }

    .img3 {
      width: 38rem;
      height: 37rem;
    }
  }
}

.aside {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, .9);
  color: #cdcdcd;
  font-size: 38rem;
  font-weight: bold;

  .nav {
    position: absolute;
    top: 350rem;
    width: 100%;

    a {
      display: block;
      height: 36rem;
      margin-top: 50rem;
      margin-bottom: 50rem;
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center;
      text-indent: -9999rem;

      &.n1 {
        background-image: url(../../assets/images/mobile/menu_1.png);

        &.active {
          background-image: url(../../assets/images/mobile/menu_1_a.png);
        }
      }

      &.n2 {
        background-image: url(../../assets/images/mobile/menu_3.png);

        &.active {
          background-image: url(../../assets/images/mobile/menu_3_a.png);
        }
      }
    }
  }

  .link-box {
    position: absolute;
    top: 700rem;
  }
}

.btn-close {
  position: absolute;
  bottom: 60rem;
  left: 50%;
  z-index: 1002;
  width: 72rem;
  height: 72rem;
  margin-left: -36rem;
  background: url(../../assets/images/mobile/btn_close.png) no-repeat;
  background-size: 100% 100%;
}

.link-box {
  width: 596rem;
  margin-left: 94rem;
  margin-top: 30rem;

  .light-effect {
    width: 270rem;
    height: 73rem;
    margin-left: 5rem;
    margin-top: 5rem;
    border-radius: 6rem;
  }

  a {
    float: left;
    width: 280rem;
    height: 80rem;
    margin-right: 18rem;
    margin-bottom: 12rem;
    background-size: 100% 100%;
  }

  .gp {
    background-image: url(../../assets/images/mobile/btn_gp.png);
  }

  .app {
    background-image: url(../../assets/images/mobile/btn_ios.png);
  }

  .one {
    background-image: url(../../assets/images/mobile/btn_one.png);
  }

  .galaxy {
    background-image: url(../../assets/images/mobile/btn_galaxy.png);
  }
}

// page1
.page {
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.page1 {
  position: relative;
  height: 1620rem;
  background-image: url(../../assets/images/mobile/bg1.jpg);

  // .btn-video {
  //   display: block;
  //   width: 90rem;
  //   height: 90rem;
  //   margin-left: 557rem;
  //   margin-top: 980rem;
  //   background-image: url(../../assets/images/mobile/btn_video.png);
  //   background-size: 100% 100%;
  // }

  .btn-pre {
    display: block;
    width: 610rem;
    height: 170rem;
    margin-left: 78rem;
    background-image: url(../../assets/images/mobile/btn_main.png);
    background-size: 100% 100%;
    -webkit-animation: magnify .8s linear infinite alternate;
    -moz-animation: magnify .8s linear infinite alternate;
    animation: magnify .8s linear infinite alternate;

    .light-effect {
      width: 423rem;
      height: 102rem;
      margin-left: 48rem;
      margin-top: 46rem;
      border-top-left-radius: 50rem;
      border-top-right-radius: 20rem;
      border-bottom-left-radius: 50rem;
    }
  }

  .numbers {
    width: 604rem;
    height: 40rem;
    margin: 12rem auto;
    padding-left: 346rem;
    background-image: url(../../assets/images/mobile/p1_number.png);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;

    p {
      width: 172rem;
      text-align: center;
      line-height: 40rem;
      color: #ffe2aa;
      font-size: 40rem;
    }
  }

  .link-box {
    margin-top: 1130rem;
    overflow: hidden;
  }

  .btn-down {
    position: absolute;
    bottom: 50rem;
    left: 50%;
    z-index: 99;
    width: 126rem;
    height: 48rem;
    margin-left: -63rem;
    background-image: url(../../assets/images/mobile/btn_down.png);
    background-size: 100% 100%;
    animation: toDown 1s infinite;
  }
}

@keyframes toDown {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(10rem);
  }

  100% {
    transform: translateY(0);
  }
}

// page2
.page2 {
  height: 1620rem;
  background-image: url(../../assets/images/mobile/bg2.jpg);

  .numbers {
    width: 614rem;
    height: 78rem;
    margin: 75rem auto 20rem;
    background-image: url(../../assets/images/mobile/p2_number.png);
    background-size: 564rem 50rem;
    background-position: center right;
    background-repeat: no-repeat;

    p {
      width: 255rem;
      padding-right: 20rem;
      text-align: right;
      color: #ffe2aa;
      font-size: 52rem;
    }
  }

  .reached-box {
    .growth-bar {
      width: 690rem;
      height: 24rem;
      margin-left: 32rem;
      background-image: url(../../assets/images/mobile/growth.png);
      background-size: 100% 100%;
    }

    p {
      width: 690rem;
      height: 24rem;
      background-image: url(../../assets/images/mobile/growth2.png);
      background-size: 690rem 24rem;
      border-top-right-radius: 12rem;
      border-bottom-right-radius: 12rem;
    }
  }

  .reached {
    width: 702rem;
    margin-left: 24rem;
    margin-top: -48rem;

    img {
      width: 220rem;
      height: 292rem;
    }
  }
}

.form-box {
  width: 524rem;
  height: 926rem;
  margin-left: 114rem;
  padding-top: 645rem;

  .os-box {
    p {
      background-size: 100% 100%;
    }

    .os {
      position: relative;
      display: inline-block;
      width: 24rem;
      height: 24rem;
      margin-right: 17rem;
      border: 1rem solid #fff;

      &.active::after {
        position: absolute;
        top: 4rem;
        left: 4rem;
        z-index: 9;
        width: 12rem;
        height: 12rem;
        background-color: #fff;
        content: "";
      }
    }

    .gp {
      width: 184rem;
      height: 38rem;
      background-image: url(../../assets/images/mobile/os_gp.png);
    }

    .app {
      width: 154rem;
      height: 38rem;
      background-image: url(../../assets/images/mobile/os_ios.png);
    }
  }

  .input-box {
    position: relative;
    width: 524rem;
    margin-top: 15rem;
    margin-bottom: 15rem;
    border-bottom: 1rem solid #fff;

    span {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 63rem;
      color: #fff;
      font-size: 32rem;
      font-weight: bold;
      font-family: 'SimHei';
      line-height: 50rem;
    }

    .input-txt {
      width: 100%;
      height: 50rem;
      padding-left: 63rem;
      background: transparent;
      color: #fff;
      font-size: 24rem;
      line-height: 50rem;
    }
  }

  .check-box {
    margin-bottom: 5rem;

    .check {
      position: relative;
      display: inline-block;
      width: 22rem;
      height: 22rem;
      margin-right: 12rem;
      border: 1rem solid #fff;

      &.active::after {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9;
        width: 16rem;
        height: 16rem;
        background-image: url(../../assets/images/mobile/i_checked.png);
        background-size: 100% 100%;
        content: "";
      }
    }

    .txt {
      color: #898989;
      font-size: 24rem;
      text-decoration: underline;
    }
  }

  .btn-submit {
    display: block;
    width: 600rem;
    height: 122rem;
    margin-left: -36rem;
    background-image: url(../../assets/images/mobile/btn_pre2.png);
    background-size: 100% 100%;
    -webkit-animation: magnify .8s linear infinite alternate;
    -moz-animation: magnify .8s linear infinite alternate;
    animation: magnify .8s linear infinite alternate;

    .light-effect {
      width: 460rem;
      height: 94rem;
      margin-left: 72rem;
      margin-top: 14rem;
      border-radius: 30rem;
    }
  }
}

.light-effect {
  position: relative;
  float: left;
  display: inline;
  overflow: hidden;

  .effect {
    position: absolute;
    top: 0;
    left: -100%;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: url(../../assets/images/btn_light.png) no-repeat;
    background-size: 100%;
    transition: all 650ms;
    -webkit-animation: sg 2s linear infinite;
    -moz-animation: sg 2s linear infinite;
    -ms-animation: sg 2s linear infinite;
    animation: sg 2s linear infinite;
  }
}

@keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-webkit-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-moz-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-o-keyframes sg {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

@-webkit-keyframes magnify {
  0% {
    -webkit-transform: scale(0.96);
  }

  100% {
    -webkit-transform: scale(1);
  }
}

@-moz-keyframes magnify {
  0% {
    -moz-transform: scale(1);
  }

  100% {
    -moz-transform: scale(0.96);
  }
}

@keyframes magnify {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.96);
  }
}

// page3
.page3 {
  height: 1621rem;
  background-image: url(../../assets/images/mobile/bg3.jpg);

  .btn-rule {
    display: block;
    width: 460rem;
    height: 94rem;
    margin: 1368rem auto 0;
    background-image: url(../../assets/images/mobile/btn_rule.png);
    background-size: 100% 100%;
  }
}

// page4
.page4 {
  height: 1620rem;
  background-image: url(../../assets/images/mobile/bg4.jpg);

  .lottery-box {
    position: relative;
    width: 588rem;
    height: 597rem;
    margin-left: 78rem;
    margin-top: 754rem;

    p {
      position: absolute;
      z-index: 1;
      background-size: 100% 100%;
    }

    .l1 {
      left: 294rem;
      width: 281rem;
      height: 303rem;
      background-image: url(../../assets/images/mobile/lottery_1.png);
    }

    .l2 {
      top: 211rem;
      right: -1rem;
      width: 294rem;
      height: 329rem;
      background-image: url(../../assets/images/mobile/lottery_2.png);
    }

    .l3 {
      left: 121rem;
      bottom: 0;
      width: 346rem;
      height: 294rem;
      background-image: url(../../assets/images/mobile/lottery_3.png);
    }

    .l4 {
      left: -2rem;
      top: 208rem;
      width: 298rem;
      height: 333rem;
      background-image: url(../../assets/images/mobile/lottery_4.png);
    }

    .l5 {
      left: 11rem;
      top: 0;
      width: 285rem;
      height: 303rem;
      background-image: url(../../assets/images/mobile/lottery_5.png);
    }

    .l6 {
      top: 47rem;
      left: 0;
      width: 295rem;
      height: 256rem;
      background-image: url(../../assets/images/mobile/lottery_6.png);
    }

    .btn-lottery {
      position: absolute;
      top: 195rem;
      left: 194rem;
      z-index: 2;
      width: 204rem;
      height: 204rem;
      background-image: url(../../assets/images/mobile/btn_lottery.png);
      background-size: 100% 100%;
      animation: breath 2.5s infinite;
    }
  }
}

// 呼吸效果
@keyframes breath {
  0% {
    transform: scale(.95);
  }

  50% {
    transform: scale(1.05);
  }

  100% {
    transform: scale(.95);
  }
}

.page5 {
  position: relative;
  height: 1106rem;
  margin-bottom: 105rem;
  background-image: url(../../assets/images/mobile/bg5.jpg);

  .swiper {
    width: 660rem;
    margin-top: 298rem;
  }

  .swiper-slide {
    width: 660rem;
    height: 380rem;

    img {
      width: 100%;
    }
  }

  .btn-slide {
    position: absolute;
    top: 460rem;
    z-index: 10;
    width: 42rem;
    height: 60rem;
    background: transparent;
    background-size: 100% 100%;
  }

  .btn-prev {
    left: 5rem;
    background-image: url(../../assets/images/mobile/btn_prev.png);
  }

  .btn-next {
    right: 5rem;
    background-image: url(../../assets/images/mobile/btn_next.png);
  }

  .pagination {
    text-align: center;
  }

  :deep(.swiper-pagination-bullet) {
    width: 60rem;
    height: 3rem;
    margin-left: 12rem;
    margin-right: 12rem;
    background-color: #816842;
    border-radius: 0;
    opacity: 1;

    &.swiper-pagination-bullet-active {
      position: relative;
      width: 120rem;
      height: 4rem;
      background-color: #d0b88f;
      outline: none;

      &::after {
        position: absolute;
        top: -12rem;
        left: 50%;
        margin-left: -6rem;
        border: 6rem solid transparent;
        border-bottom-color: #d0b88f;
        content: '';
      }
    }
  }

}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 156rem;

  .swiper-slide {
    width: 750rem;
    height: 156rem;
    background-size: 100% 100%;
    img {
      width: 100%;
    }
  }
  .swiper-slide-active{
    opacity: 1;
  }

  .btns {
    position: absolute;
    left: 246rem;
    top: 55rem;
    z-index: 101;
    .btn{
      display: block;
      width: 156rem;
      height: 44rem;
      margin-bottom: 5rem;
      background-size: 100% 100%;
    }
    .ios {
      background-image: url(../../assets/images/mobile/ft_ios.png);
    }

    .gp {
      background-image: url(../../assets/images/mobile/ft_gp.png);
    }
    .naver {
      background-image: url(../../assets/images/mobile/btn_naver.png);
    }
  }
}

// 弹窗
.popup-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  width: 100%;
  background: rgba(0, 0, 0, .8);

  .inner {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 999;
    width: 666rem;
    margin-left: -333rem;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }

  .btn-close {
    top: -112rem;
    left: 600rem;
    z-index: 1000;
    margin-left: 0;
  }

  &.popup-login {
    transform: perspective(400px);
    -ms-transform: perspective(400px);
    -moz-transform: perspective(400px);
    -webkit-transform: perspective(400px);
    -o-transform: perspective(400px);
    .inner {
      top: auto;
      bottom: 0;
      width: 750rem;
      height: 1351rem;
      margin-left: -375rem;
      margin-top: 0;
      background-image: url(../../assets/images/mobile/pop_form.png);
      background-position: bottom center;
    }

    .form-box {
      position: absolute;
      bottom: 0;
      padding-top: 585rem;
    }

    .btn-close {
      top: auto;
      left: 615rem;
      bottom: 774rem;
    }
  }

  &.popup-success {
    .inner {
      height: 550rem;
      margin-top: -275rem;
      background-image: url(../../assets/images/mobile/pop_suc.jpg);
      background-size: 100% 100%;
    }

    .btn-link {
      display: block;
      width: 450rem;
      height: 96rem;
      margin-left: 110rem;
      margin-top: 110rem;
      background-image: url(../../assets/images/mobile/btn_lounge.png);
      background-size: 100% 100%;
    }
  }

  &.popup-rules, &.popup-privacy {
    .inner {
      height: 550rem;
      margin-top: -275rem;
      background-image: url(../../assets/images/mobile/pop_large.jpg);
      background-size: 100% 100%;
    }

    .rules, .privacy {
      padding: 30rem 30rem;
      color: #fff;
      font-size: 26rem;

      h3 {
        text-align: center;
        font-weight: bold;
        font-size: 30rem;
      }
    }
  }

  &.popup-alert {
    .inner {
      height: 266rem;
      margin-top: -133rem;
      background-image: url(../../assets/images/mobile/pop_s.jpg);
      background-size: 100% 100%;
      color: #fff;
      font-size: 26rem;
    }

    .text {
      height: 100%;
      padding: 0 30rem;
    }
  }

  
  &.popup-again {
    .inner {
      height: 320rem;
      margin-top: -160rem;
      background-image: url(../../assets/images/mobile/pop_s.jpg);
      background-size: 100% 100%;
      color: #fff;
      font-size: 26rem;
    }

    .text {
      height: 100%;
      padding: 0 30rem;
    }
    .btn-link {
      display: block;
      width: 450rem;
      height: 96rem;
      background-image: url(../../assets/images/mobile/btn_lounge.png);
      background-size: 100% 100%;
      transform: scale(0.8);
    }
  }

  &.popup-videos {
    .inner {
      width: 750rem;
      height: 422rem;
      margin-left: -375rem;
      margin-top: -211rem;
      background-color: #000;
    }
  }
}</style>
 